if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dom.production.js');
} else {
  module.exports = require('./dom.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/dom/dist/es/dom.js
// module id = 1337
// module chunks = 0